import { Component, inject } from '@angular/core';
import { Paging } from 'projects/patient/src/app/core/types/helper.model';
import { SubscriptionService } from '../../services/subscription.service';
import { map, Observable } from 'rxjs';
import { PagingMaster } from 'projects/shared-ui/src/public-api';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthStore } from 'projects/patient/src/app/core/auth/store/auth.store';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';

@Component({
  selector: 'patient-plan-list',
  imports: [CommonModule, ButtonModule, SelectButtonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './plan-list.component.html',
  styleUrl: './plan-list.component.css',
})
export class PlanListComponent {
  _subscriptionServices = inject(SubscriptionService);
  private authStore = inject(AuthStore);
  private  authService = inject(AuthService)

  plans: any;
  checkoutData: any = null;
  patientId :string =" "

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
  };

  selectedDuration: number =2;

  pricingTierMap: Record<number, string> = {
    1: 'MONTHLY',
    2: 'QUARTERLY',
    3: 'BIANNUALLY',
    4: 'ANNUALLY',
  };

  billingOptions = [
    { label: 'Monthly', value: 1 },
    { label: 'Quarterly', value: 2 },
    { label: 'Biannually', value: 3 },
    { label: 'Annually', value: 4 },
  ];

  ngOnInit(): void {

    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
         this.fetchPlans();

      }
    });
  }

  loadData = (data: Paging): Observable<PagingMaster<any>> => {
    return this._subscriptionServices.getSubscriptionPlans(this.patientId).pipe(
      map((res: any) => {
        this.plans = Array.isArray(res.data) ? res.data : [];

        // Default selected tier (first one sorted)
        this.plans.forEach((plan: any) => {
          const sorted = this.sortedPricingTiers(plan);
          if (sorted.length) {
            this.plans[plan.id] = sorted[0].duration;
          }
        });

        return {
          data: this.plans,
          paging: res.paging ?? data,
          message: 'Success',
        };
      }),
    );
  };

  fetchPlans() {
    this.loadData(this.paging).subscribe({
      next: (res) => {
        // this.plans = res.data.filter((plan: any) => plan.name != 'Free');
         this.plans = res.data.sort((a, b) => a.plan_order - b.plan_order)
      },
      error: (err) => console.error('Error loading plans:', err),
    });
  }

  sortedPricingTiers(plan: any) {
    return [...(plan.pricing_tiers || [])].sort((a, b) => a.duration - b.duration);
  }

  getSelectedTier(plan: any) {
    return plan.pricing_tiers?.find((t: any) => t.duration === this.selectedDuration);
  }

  selectGlobalDuration(duration: number) {
    this.selectedDuration = duration;
  }

  private prepareCheckoutData(tier: any) {
    const token = this.authStore.token();
    let userId: string | null = null;

    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        userId = decoded?.user_id;
      } catch (e) {
        console.error('Token decode error', e);
      }
    }

    this.checkoutData = {
      user_id: userId,
      payment_date: new Date().toISOString(),
      payment_method: 101,
      amount: tier.price,
      payment_type: 102,
      product_info: 'Subscription',
      subscription_id: tier.subscription_plan_id,
      duration: tier.duration,
    };
  }

  payPlan(plan: any) {
    const selectedTier = this.getSelectedTier(plan);

    this.prepareCheckoutData(selectedTier);

    console.log('Paying with:', this.checkoutData);

    // Call payment API here
    this.payNow(plan.is_recurring);
  }

  payNow(isRecurring: boolean) {
    if (!this.checkoutData) {
      console.error('No checkout data available');
      return;
    }

    this._subscriptionServices.payuClick(this.checkoutData).subscribe({
      next: (res: any) => {
        console.log('PayU Response:', res);
        this.submitPayUForm(res, isRecurring);
      },
      error: (err: any) => {
        console.error('Payment initiation failed', err);
      },
    });
  }

  submitPayUForm(data: any, isRecurring: boolean) {
    const returnUrl = data.return_url;
    const payUAction = `${data.url}`;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = payUAction;
    form.target = '_blank';

    const fields = [
      'key',
      'txnid',
      'amount',
      'productinfo',
      'firstname',
      'email',
      'phone',
      'surl',
      'furl',
      'hash',
    ];

    if (isRecurring === true) {
      fields.push('api_version', 'si', 'si_details');
    }

    fields.forEach((field) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field;

      if (field === 'surl' || field === 'furl') {
        input.value = returnUrl;
      } else if (data[field] !== undefined) {
        input.value = data[field];
      } else {
      return; 
    }
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
/*
  isActivePlan(plan: any): boolean {
    return plan.plan_order === 1;
  } */ 
}
